@if (isVisible()) {
  <div class="spinner-overlay">
    <div class="spinner-container">
      <i class="fas fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
}
